/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputDirection } from './OutputDirection';
import {
    OutputDirectionFromJSON,
    OutputDirectionFromJSONTyped,
    OutputDirectionToJSON,
} from './OutputDirection';

/**
 * 
 * @export
 * @interface OutputAdminZone
 */
export interface OutputAdminZone {
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminZone
     */
    allowAdditionalMissionTime: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminZone
     */
    centerCoordinates?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAdminZone
     */
    dambaIntegration: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminZone
     */
    deltaLink: string;
    /**
     * 
     * @type {Array<OutputDirection>}
     * @memberof OutputAdminZone
     */
    directions: Array<OutputDirection>;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminZone
     */
    flightTimeoutMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminZone
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminZone
     */
    leftZoneId: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminZone
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminZone
     */
    osgId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminZone
     */
    osgName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminZone
     */
    otgId: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminZone
     */
    otgName: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminZone
     */
    radius?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminZone
     */
    rightZoneId: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminZone
     */
    signalLink: string;
}

/**
 * Check if a given object implements the OutputAdminZone interface.
 */
export function instanceOfOutputAdminZone(value: object): boolean {
    if (!('allowAdditionalMissionTime' in value)) return false;
    if (!('dambaIntegration' in value)) return false;
    if (!('deltaLink' in value)) return false;
    if (!('directions' in value)) return false;
    if (!('flightTimeoutMinutes' in value)) return false;
    if (!('id' in value)) return false;
    if (!('leftZoneId' in value)) return false;
    if (!('name' in value)) return false;
    if (!('otgId' in value)) return false;
    if (!('otgName' in value)) return false;
    if (!('rightZoneId' in value)) return false;
    if (!('signalLink' in value)) return false;
    return true;
}

export function OutputAdminZoneFromJSON(json: any): OutputAdminZone {
    return OutputAdminZoneFromJSONTyped(json, false);
}

export function OutputAdminZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminZone {
    if (json == null) {
        return json;
    }
    return {
        
        'allowAdditionalMissionTime': json['allowAdditionalMissionTime'],
        'centerCoordinates': json['centerCoordinates'] == null ? undefined : json['centerCoordinates'],
        'dambaIntegration': json['dambaIntegration'],
        'deltaLink': json['deltaLink'],
        'directions': ((json['directions'] as Array<any>).map(OutputDirectionFromJSON)),
        'flightTimeoutMinutes': json['flightTimeoutMinutes'],
        'id': json['id'],
        'leftZoneId': json['leftZoneId'],
        'name': json['name'],
        'osgId': json['osgId'] == null ? undefined : json['osgId'],
        'osgName': json['osgName'] == null ? undefined : json['osgName'],
        'otgId': json['otgId'],
        'otgName': json['otgName'],
        'radius': json['radius'] == null ? undefined : json['radius'],
        'rightZoneId': json['rightZoneId'],
        'signalLink': json['signalLink'],
    };
}

export function OutputAdminZoneToJSON(value?: OutputAdminZone | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'allowAdditionalMissionTime': value['allowAdditionalMissionTime'],
        'centerCoordinates': value['centerCoordinates'],
        'dambaIntegration': value['dambaIntegration'],
        'deltaLink': value['deltaLink'],
        'directions': ((value['directions'] as Array<any>).map(OutputDirectionToJSON)),
        'flightTimeoutMinutes': value['flightTimeoutMinutes'],
        'id': value['id'],
        'leftZoneId': value['leftZoneId'],
        'name': value['name'],
        'osgId': value['osgId'],
        'osgName': value['osgName'],
        'otgId': value['otgId'],
        'otgName': value['otgName'],
        'radius': value['radius'],
        'rightZoneId': value['rightZoneId'],
        'signalLink': value['signalLink'],
    };
}

